export default __webpack_public_path__ + "static/media/S4.60095b5a.svg";